/*
 * Striped image placeholder. Stand in for imagery like a property photo.
 */
import React from 'react';

function GpImagePlaceholder({ label = 'property photo', aspect = '4 / 3', style = {} }) {
  return (
    <div
      style={{
        width: '100%',
        aspectRatio: aspect,
        borderRadius: 'var(--gp-r-md)',
        background:
          'repeating-linear-gradient(135deg, #E5E1D4 0px, #E5E1D4 8px, #EFECE1 8px, #EFECE1 16px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#8A8778',
        font: '400 11px/1.2 var(--gp-mono)',
        letterSpacing: 0.2,
        ...style,
      }}
    >
      {label}
    </div>
  );
}

export default GpImagePlaceholder;
